import { useTranslation } from 'react-i18next';

import { Card } from '@/components/atoms/Card';
import PageLayout from '@/components/Layout/PageLayout';

import ChipsButtons from './components/ChipsButtons';
import Screens from './components/Screens';
import { Hello, StreamLoadingBanner } from './components/VideoBanners';
import type { LocationVideoStreams } from './useLocationVideoStreams';

type LocationVideoViewProps = LocationVideoStreams;

export default function LocationVideoView(props: LocationVideoViewProps) {
    const {
        activeCages,
        allButtonState,
        onlyViewMode,
        showSpinner,
        showHello,
        cageChanged,
        allCagesChanged,
    } = props;
    const { t } = useTranslation();

    return (
        <PageLayout title={t('location.video.video')}>
            <section>
                <ChipsButtons
                    cageChangedHandler={cageChanged}
                    allCagesChangedHandler={allCagesChanged}
                    activeCagesButtons={activeCages}
                    allButton={allButtonState}
                    onlyViewMode={onlyViewMode}
                />
                {showSpinner && <StreamLoadingBanner t={t} />}
                {<br />}
            </section>

            <Card>
                <section>
                    <Screens activeCages={activeCages} onlyViewMode={onlyViewMode} />
                    {showHello && <Hello t={t} />}
                </section>
            </Card>
        </PageLayout>
    );
}
